'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isNextMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isNextMonth.js
// module id = 237
// module chunks = 1